import { useState, Dispatch, SetStateAction, useCallback } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/16/solid';
import { useTranslation } from 'react-i18next';

import Title from 'pages/FlightOffer/Title';
import AttendeeBox from './AttendeeBox';
import { ITravelRequestPerson } from 'entities/Flights/sdk';
import AgreementCheckbox from 'pages/FlightOffer/AgreementCheckbox';

const AttendeesSection = ({
  people,
  hasAlreadyAgreed,
  isPersonalInfoAgreed,
  setPersonalInfoAgreed,
}: {
  people: ITravelRequestPerson[];
  hasAlreadyAgreed: boolean;
  isPersonalInfoAgreed: boolean;
  setPersonalInfoAgreed: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const toggleAttendeesSection = useCallback(() => {
    setOpen((prevOpen) => !prevOpen);
  }, []);

  return (
    <div className='flex flex-col max-lg:gap-[16px]'>
      <div className='flex justify-between max-lg:flex-col max-lg:items-center max-lg:gap-[16px]'>
        <Title text={t('flightOffer.attendees')} />
        <AgreementCheckbox
          label={t('flightOffer.agreePersonalInfo')}
          checked={isPersonalInfoAgreed || hasAlreadyAgreed}
          onChange={setPersonalInfoAgreed}
          disabled={hasAlreadyAgreed}
        />
      </div>
      <div
        onClick={toggleAttendeesSection}
        className='p-[10px] rounded-[12px] shadow-[4px_4px_4px_4px_rgba(0,0,0,0.04)] flex justify-between cursor-pointer'
      >
        <div className='flex gap-[6px]'>
          <div className='w-[24px] h-[24px] rounded-[50%] bg-primary text-white flex items-center justify-center'>
            {people.length}
          </div>
          <div className='font-[MuseoSansCyrl] text-grey700'>{t('flightOffer.showAllAttendees')}</div>
        </div>
        {open ? <ChevronUpIcon className='size-4 fill-grey500' /> : <ChevronDownIcon className='size-4 fill-grey500' />}
      </div>
      {open && (
        <div className='p-4 flex gap-[24px] flex-wrap shadow-md rounded-xl'>
          {people.map((person) => (
            <AttendeeBox person={person} />
          ))}
        </div>
      )}
    </div>
  );
};

export default AttendeesSection;
